import React from 'react';
import { useLocation } from 'react-router-dom';
import AppNav from './AppNav';

/**
 * App shell that provides theme scoping and navigation.
 * Sets data-theme attribute based on current route for CSS custom properties.
 */
export default function Layout({ children }) {
  const location = useLocation();
  const theme = getThemeForPath(location.pathname);

  return (
    <div
      data-theme={theme}
      className="min-h-screen theme-bg theme-text"
    >
      <AppNav />
      <main key={location.pathname} className="max-w-7xl mx-auto page-enter">
        {children}
      </main>
    </div>
  );
}

function getThemeForPath(path) {
  if (path.startsWith('/flashcards')) return 'flashcards';
  if (path.startsWith('/matrix')) return 'matrix';
  if (path.startsWith('/drill')) return 'drill';
  if (path.startsWith('/exam')) return 'exam';
  return 'flashcards'; // Landing page uses dark theme
}
